export const AUTH_HEADER = {
  PRODUCTION: 'Authorization',
  DEVELOPMENT: 'Clerk-Db-Jwt',
};

export const CLIENT_JWT_KEY = '__client';
export const CLIENT_UAT_KEY = '__clerk_uat';
export const DEFAULT_LOCAL_HOST_PERMISSION = 'http://localhost';
export const STORAGE_KEY_CLIENT_JWT = '__clerk_client_jwt';
